import { Row, Col, Card, Statistic } from "antd";
import AppLayout from "../../components/AppLayout";

export default function Dashboard() {
  return (
    <Row gutter={16}>
      {/* <Col span={6}>
        <Card>
          <Statistic title="Users" value={120} />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic title="Products" value={340} />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic title="Orders" value={89} />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic title="Revenue" value={54000} prefix="£" />
        </Card>
      </Col> */}

      <Col span={24} style={{ textAlign: "center", marginTop: 50 }}>
        <h1>Welcome to the Admin Dashboard !</h1>
      </Col>
    </Row>
  );
}
